export const SET_COMPROVANTE_SOLICITACAO = "deca.SET_COMPROVANTE_SOLICITACAO";
export const GET_COMPROVANTE_SOLICITACAO = "deca.GET_COMPROVANTE_SOLICITACAO";
export const GET_IMPRIMIR_COMPROVANTE = "deca.GET_IMPRIMIR_COMPROVANTE";

